<template>
    <LayoutSub>
        <SubSection class="pb-0">
            <h1>페이지 작업중</h1>
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>
<style lang="scss" scoped>
h1 {
    font-size: 32px;
    text-align: center;
}
</style>
